__webpack_require__.p = "/Quizzical/";